
    import '/opt/buildhome/repo/docs/spec/feedback-result-display.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/docs/spec/feedback-result-display.zh-CN.md?type=demo')
};